import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { orderBy, cloneDeep } from 'lodash';
import moment from 'moment';
import queryString from 'query-string';

import { connect } from 'react-redux';

import { GridColumn as Column } from '@progress/kendo-react-grid';
import AgentStatus from '../../../components/AgentStatus';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';
import BobTable from '../../../components/BobTable';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';
import { getTimeZoneAbbr } from '../../../helpers/timezones';

import * as BobActions from '../../../actions/bobActions';
import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './ExecutiveSummaryAgentsTable.module.css';

const ExecutiveSummaryAgentsTable = ({
    basAgents,
    bobLoading,
    expanded,
    history,
    targetNavCompany,
    updatedAt,
    ...props
}) => {
    const [data, setData] = useState([]);
    useEffect(() => {
        const agents = basAgents.map(agent => {
            const {actions, driverConfiguration, site} = agent;
            const sites = site ? site.map(s => s.name).join(', ') : '';
            agent.basType = driverConfiguration[0].basType;
            agent.sites = sites;
            agent.lastPollCompleted = actions?.poll?.timeCompleted ? actions.poll.timeCompleted : null;
            agent.orderBy = agent.connected === false ? 0 : agent.connected === true ? 1 : 2;
            return agent;
        });
        const orderedData = cloneDeep(orderBy(agents, ['orderBy'], ['asc']));
        setData(orderedData);
    }, [basAgents]);

    const renderNavUrl = dataItem => {
        const queryValues = queryString.parse(history.location.search);
        return `/iothub/basagents/manage?company=${ queryValues.company }&basAgent=${ dataItem.id }`;
    };

    const statusHeaderCell = props => {
        return (
            <div className={props.className} style={props.style}>
                <div role={'none'} style={{width: '40px', height: '100%', cursor: 'pointer'}} onClick={props.onClick}>
                    &nbsp;{props.children}
                </div>
            </div>
        );
    };

    const statusCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <AgentStatus agent={props.dataItem} showHtmlTooltip={true} />
            </td>
        );
    };

    const nameCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.Parent}>{`${props.dataItem[props.field]}`}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div className={classes.OverflowCell}>
                            <Link
                                to={renderNavUrl(props.dataItem)}
                            >
                                {props.dataItem[props.field]}
                            </Link>
                        </div>
                    }
                />
            </td>
        );
    };

    const lastPollTimeCell = props => {
        let zone = moment.tz.guess();
        let fd = props.dataItem.lastPollCompleted ? moment(props.dataItem.lastPollCompleted).format('YYYY-MM-DD h:mm A') : '';     
        const timeDisplay = props.dataItem.lastPollCompleted ? fd + ' ' + getTimeZoneAbbr(props.dataItem.lastPollCompleted, zone) : '';
        return (
            <td className={props.className} style={props.style}>
                <HtmlTooltip
                    information={<React.Fragment><div className={classes.Parent}>{`${timeDisplay}`}</div></React.Fragment>}
                    placement="top-start"
                    body={
                        <div className={classes.OverflowCell}>
                            {timeDisplay}
                        </div>
                    }
                />
            </td>
        );
    };

    const footerCell = props => {
        let zone = moment.tz.guess();
        let time = moment(updatedAt).format('YYYY-MM-DD h:mm:ss A') + ' ' + getTimeZoneAbbr(updatedAt, zone);
        return (
            <td colSpan={3} style={props.style}>
                {`Last Updated: ${time}`}
            </td>
        );
    };

    const columns = [
        <Column
            key={0}
            field={'orderBy'}
            title=""
            width={45}
            cell={statusCell}
            headerCell={statusHeaderCell}
            footerCell={footerCell}
        />,
        <Column
            key={1}
            field={'name'}
            id="name"
            title={'Agent'}
            cell={nameCell}
            width={expanded ? 500 : 'auto'}
        />,
        <Column
            key={2}
            field={'lastPollCompleted'}
            title={'Last Polled'}
            width={200}
            cell={lastPollTimeCell}
        />,
        <Column
            key={3}
            field={'sensorCount'}
            title={'Points'}
            width={98}
        />
    ];

    return (
        <ExecutiveSummaryTile isLoading={bobLoading.includes('FetchBasAgents')}>
            {
                bobLoading.includes('FetchBasAgents') ?
                    <div className={classes.Loader}>
                        <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                    </div>
                    :
                    <BobTable
                        altStyle={true}
                        data={data}
                        columns={columns}
                        className={classes.AgentGrid}
                        isPageable={false}
                    />
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    const { basAgents, order, orderBy: orderByKey, updatedAt } = state.basAgent;
    return {
        basAgents:        orderBy(Object.values(basAgents), [orderByKey], order),
        bobLoading:       state.bob.bobLoading,
        targetNavCompany: state.bob.targetNavCompany,
        order,
        orderBy:          orderByKey,
        updatedAt
    };
};

const mapDispatchToProps = ({
    ...BobActions,
    ...BasAgentActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExecutiveSummaryAgentsTable));
